import { defineComponent, computed, createElementBlock, openBlock, normalizeClass, renderSlot, createCommentVNode, createElementVNode, toDisplayString } from "vue";
import { _export_sfc } from "../WAccordion/index.js";
import './index.css';const _hoisted_1$1 = {
  key: 0,
  class: "w-card__header"
};
const _hoisted_2$1 = {
  key: 1,
  class: "w-card__footer"
};
const _sfc_main$1 = /* @__PURE__ */ defineComponent({
  __name: "WCard",
  props: {
    hovered: { type: Boolean }
  },
  setup(__props) {
    const props = __props;
    const classes = computed(() => [
      {
        "--hovered": props.hovered
      }
    ]);
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("article", {
        class: normalizeClass(["w-card", classes.value])
      }, [
        renderSlot(_ctx.$slots, "additional", {}, void 0, true),
        _ctx.$slots["header"] ? (openBlock(), createElementBlock("header", _hoisted_1$1, [
          renderSlot(_ctx.$slots, "header", {}, void 0, true)
        ])) : createCommentVNode("", true),
        _ctx.$slots["footer"] ? (openBlock(), createElementBlock("footer", _hoisted_2$1, [
          renderSlot(_ctx.$slots, "footer", {}, void 0, true)
        ])) : createCommentVNode("", true)
      ], 2);
    };
  }
});
const WCard = /* @__PURE__ */ _export_sfc(_sfc_main$1, [["__scopeId", "data-v-c698316a"]]);
const _hoisted_1 = { class: "w-casino-card-title" };
const _hoisted_2 = {
  key: 0,
  class: "w-casino-card-title__left-content"
};
const _hoisted_3 = { class: "w-casino-card-title__content" };
const _hoisted_4 = { class: "w-casino-card-title__title" };
const _hoisted_5 = {
  key: 0,
  class: "w-casino-card-title__subtitle"
};
const _hoisted_6 = {
  key: 1,
  class: "w-casino-card-title__right-content"
};
const _sfc_main = /* @__PURE__ */ defineComponent({
  __name: "WCardTitle",
  props: {
    title: {},
    subtitle: {}
  },
  setup(__props) {
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("div", _hoisted_1, [
        _ctx.$slots["leftContent"] ? (openBlock(), createElementBlock("div", _hoisted_2, [
          renderSlot(_ctx.$slots, "leftContent", {}, void 0, true)
        ])) : createCommentVNode("", true),
        createElementVNode("div", _hoisted_3, [
          createElementVNode("h1", _hoisted_4, toDisplayString(_ctx.title), 1),
          _ctx.subtitle ? (openBlock(), createElementBlock("h2", _hoisted_5, toDisplayString(_ctx.subtitle), 1)) : createCommentVNode("", true)
        ]),
        _ctx.$slots["rightContent"] ? (openBlock(), createElementBlock("div", _hoisted_6, [
          renderSlot(_ctx.$slots, "rightContent", {}, void 0, true)
        ])) : createCommentVNode("", true)
      ]);
    };
  }
});
const WCardTitle = /* @__PURE__ */ _export_sfc(_sfc_main, [["__scopeId", "data-v-bcd55f7d"]]);
export {
  WCard,
  WCardTitle
};
